import { Prompt, PromptParameter, TemplateParameters } from ".."

export interface IRephraseState {
    prompts: Prompt[],

    /* Define the prompt parameters. It is an array because a prompt can have multiple prompt parameters
       For instance, he can have one prompt parameters called "examples" for each authorized lang */
    promptParameters: PromptParameter[],
    /* List of templates names from CordialLLM templates */
    templateParameters: TemplateParameters[],
    /* List of authorized langs */
    langs: string[],
    /* Current prompt id displayed on rephrasing view */
    currentPromptId: string
  }
  
  export const RephraseState = (): IRephraseState => {
    return {
      prompts: [],
      promptParameters: [],
      templateParameters: [],
      langs: [],
      currentPromptId: ""
    }
  }
  